import BaseService from './base.service';

export default class AuthService extends BaseService {
  login(data) {
    return this.createWithNoHeader('user/login', data);
  }

  resetPassword(data) {
    return this.createWithNoHeader('user/reset_password/', data);
  }

  forgotPassword(data) {
    return this.createWithNoHeader('user/forgot_password/', data);
  }

  identify(data, uuid) {
    return this.createWithNoHeader(`summary/view/${uuid}`, data);
  }
}
